import commonHelper from '@/app/utility/common.helper.utility';
import appStrings from '@/app/utility/string.utility';
import binDetails from '../binDetails';
export default {
  name: 'assetLocators',
  components: {
    binDetails
  },
  props: ['shelfRowData', 'faLocId'],
  watch: {
    currentPage: function() {
      this.getLocDetailsById();
    },
    perPage: function() {
      this.currentPage = 1;
      this.getLocDetailsById();
    }
  },
  data() {
    return {
      totalRows: null,
      currentPage: 1,
      loader: false,
      perPage: commonHelper.perPageRecord,
      pageOptions: commonHelper.getPageOption(),
      editMode: false,
      showAlert: false,
      isSuccess: false,
      responseMsg: '',
      locCode: null,
      locName: null,
      status: {
        value: null,
        text: null
      },
      freeze: {
        value: null,
        text: null
      },
      location: {
        value: null,
        text: null
      },
      shelfData: [
        {
          locator_name: null,
          locator_code: null,
          status: 'ACTIVE',
          parent_locator_id: null,
          fa_location_id: null,
          locator_id: 0,
          freeze_status: 'UNFREEZE'
        }
      ],
      shelfFields: [
        {
          key: 'add',
          stickyColumn: true,
        },
        {
          key: 'remove',
          stickyColumn: true
        },
        {
          key: 'addBin',
          class: 'bin-col'
        },
        {
          key: 'locator_name',
          label: 'Shelf Name'
        },
        {
          key: 'locator_code',
          label: 'Shelf Code'
        },
        {
          key: 'status'
        },
        {
          key: 'freeze_status'
        },
        {
          key: 'created_by'
        },
        {
          key: 'creation_date'
        }
      ],
      payload: null,
      showValueSetModal: false,
      showBinModal: false,
      binRowData: null,
      accessButton: false,
      cntShelf:0,
    };
  },
  mounted() {
    if (this.$store.state.shared.accessRights) {
      const buttonRights = this.$store.state.shared.accessRights;
      if (buttonRights.edit_allow && buttonRights.add_allow) {
        this.accessButton = true;
      } else {
        this.accessButton = false;
      }
    }
    if (this.shelfRowData) {
      this.fillHdrRecordFromRack(this.shelfRowData);
    } else {
      this.editMode = true;
    }
    // this.unsubscribe = this.$store.subscribe((mutation, state) => {
    //   if (mutation.type === 'shared/setActionName') {
    //     const actionName = state.shared.actionName;
    //     if (actionName === 'update') {
    //       // this.editMode = true;
    //     }
    //   }
    // });
  },
  methods: {
    editShelfModal() {
      this.editMode = true;
    },
    fillHdrRecordFromRack(item) {
      this.location.text = item.concatenated_segment;
      this.location.value = item.concatenated_segment;
      this.locName = item.locator_name;
      this.locCode = item.locator_code;
      this.status.text = item.status;
      this.status.value = item.status;
      this.getLocDetailsById();
    },
    getLocDetailsById() {
      const payload = {
        pathVariable:{ 
          faLocId: this.faLocId,      
          },
        params:{
          parent_locator_id: this.shelfRowData.locator_id,
          page: this.currentPage - 1,
          limit: this.perPage,
        }
      };
      this.loader = true;
      this.$store
        .dispatch('assets/getLocDetailsById', payload)
        .then(resp => {
          this.loader = false;
          if (resp.status === 200) {
            const result = resp.data.data.page;
            this.totalRows = resp.data.data.total_elements;
            if (result.length) {
              this.shelfData = result;
              this.shelfData.map(ele=>{
                if(ele.freeze_status=="FREEZE"
                  ){
                    this.cntShelf++
                  }
              })
              if(this.cntShelf==result.length){
                this.shelfFields[0].class="d-none"
                this.cntShelf=0
              }else{
                this.shelfFields[0].class=""
                this.cntShelf=0
              }
            }
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    addEditShelfDetails() {
      const payload = this.shelfData.map(item => {
        return {
          fa_location_id: item.fa_location_id
            ? item.fa_location_id
            : this.shelfRowData.fa_location_id,
          locator_code: item.locator_code,
          locator_id: item.locator_id,
          locator_name: item.locator_name,
          parent_locator_id: item.parent_locator_id
            ? item.parent_locator_id
            : this.shelfRowData.locator_id,
          status: item.status,
          freeze_status: item.freeze_status
        };
      });
      var count=0;
      payload.map(item=>{
        if(item.locator_code==null || item.locator_name==null){
         count++
        }
      })
      if(count>0){
        this.$bvToast.toast("Shelf name and Shelf code can not be null", {
          title: 'Alert',
          variant: 'danger',
          solid: true
        });
      }else{
      this.loader = true;
      this.$store
        .dispatch('assets/addLocator', payload)
        .then(response => {
          this.loader = false;
          this.showAlert = true;
          if (response.status === 201) {
            this.shelfRowData.locator_id =
              response.data.data[0].parent_locator_id;
            this.isSuccess = true;
            this.responseMsg = response.data.message;
            this.editMode = false;
            this.getLocDetailsById();
            this.$emit('getLocDetailsById')
          } else {
            this.isSuccess = false;
            this.responseMsg = response.response.data.message;
          }
        })
        .catch(err => {
          this.showAlert = true;
          this.loader = false;
          this.isSuccess = false;
          this.responseMsg = appStrings.autoFailedMsg;
          this.error = err;
        });
      }
    },
    addNewRow() {
      if (this.editMode) {
        this.shelfData.push({
          freeze_status: 'UNFREEZE',
          status: 'ACTIVE',
          locator_name: null,
          locator_code: null,
          parent_locator_id: this.shelfRowData.locator_id,
          fa_location_id: 0,
          locator_id: 0
        });
      }
    },
    removeRow(index) {
      this.shelfData.splice(index, 1);
    },
    openValueSetModal(vsetCode, index) {
      this.vsetCode = vsetCode;
      this.locIndex = index;
      this.showValueSetModal = true;
      this.setTimeVsetCode = setTimeout(() => {
        const vSetData = {
          valueSetName: vsetCode,
          multiFlag: null
        };
        this.eventBus.$emit('valueSetCode', vSetData);
      }, 0);
    },
    selectedvalueSet(item) {
      if (this.vsetCode === appStrings.VALUESETTYPE.STATUS_VSET) {
        this.shelfData[this.locIndex].status = item.value_code;
      } else if (this.vsetCode === appStrings.VALUESETTYPE.FREEZE_STATUS_VSET) {
        this.shelfData[this.locIndex].freeze_status = item.value_code;
      }
      this.shelfData = JSON.parse(JSON.stringify(this.shelfData));
    },
    closeValueSetModal() {
      this.showValueSetModal = false;
    },
    clearVsetValuesOnGrid(vsetCode, index) {
      if (vsetCode === 'STATUS_VSET') {
        this.shelfData[index].status = null;
        this.shelfData[index].status = null;
      } else if (vsetCode === 'FREEZE_STATUS_VSET') {
        this.shelfData[index].freeze_status = null;
        this.shelfData[index].freeze_status = null;
      }
    },
    // rowSelected(item) {
    //   this.binRowData = item;
    //   this.showHideBinModal(true);
    // },
    showHideBinModal(flag, item) {
      this.showBinModal = flag;
      this.binRowData = item;
    }
  },
  beforeDestroy() {
    // this.unsubscribe();
  }
};
